<template>
  <button class="btn-svg" title="Copy link to this calculation" aria-label="Copy link to this calculation" @click="copy">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 12a5 5 0 0 1-5 5H7A5 5 0 0 1 7 7h.5m2.5 5a5 5 0 0 1 5-5h2a5 5 0 0 1 0 10h-.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
  </button>
</template>

<script>
export default {
  name: 'result-link-button',
  props: {
    anchor: String,
    data: Object
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(location.origin + location.pathname + '#' + encodeURIComponent(JSON.stringify({
        a: this.anchor,
        d: this.data
      })));
    }
  }
}
</script>